import { createReducer, createAction } from 'redux-act';
import { put, takeLatest } from 'redux-saga/effects';

import * as goldVehicles from '../../api-purecars/gold-vehicles';
import WHITELISTED_MAKE_NAMES from './whitelisted-oems';

const MAKES_REQUESTED = 'MAKES_REQUESTED';
const MAKES_SUCCESS = 'MAKES_SUCCESS';
const MAKES_FAILED = 'MAKES_FAILED';

export const makesRequest = createAction(MAKES_REQUESTED);
export const makesSuccess = createAction(MAKES_SUCCESS);
export const makesFailed = createAction(MAKES_FAILED);

const compareDisplayName = (a, b) => {
  const aName = a.displayName.toUpperCase();
  const bName = b.displayName.toUpperCase();
  if (aName > bName) {
    return 1;
  }
  if (aName < bName) {
    return -1;
  }
  return 0;
};

function* fetchMakes() {
  try {
    const makes = yield goldVehicles.getMakes();
    const whitelisted = makes
      .filter(make => WHITELISTED_MAKE_NAMES.has(make.displayName))
      .sort(compareDisplayName);
    yield put(makesSuccess(whitelisted));
  } catch (error) {
    yield put(makesFailed(error));
  }
}

export function watchMakeRequest() {
  return takeLatest(MAKES_REQUESTED, fetchMakes);
}

const initModelStore = { list: [] };

export const getMakesStore = (state) => {
  const { makes = {} } = state;
  return makes;
};

const handleMakesRequest = (state) => Object.assign({}, state, { loading: true });
const handleMakesSuccess = (state, makes) => Object.assign({}, state, { loading: false, list: makes });
const handleMakesFailed = (state, error) => Object.assign({}, state, { loading: false, error });

export default createReducer({
  [makesRequest]: handleMakesRequest,
  [makesSuccess]: handleMakesSuccess,
  [makesFailed]: handleMakesFailed,
}, initModelStore);



// WEBPACK FOOTER //
// ./src/main/data/makes.js